// Impostazioni predefinite del tool Preventivo (margini, IVA, commissioni POS).
// Vengono sovrascritte dal documento Firestore users/{userId}/repairCalcSettings/default.
export const DEFAULT_SETTINGS = {
  marginEasy: 20,
  marginMedium: 50,
  marginHard: 90,
  marginEasyPct: 20,
  marginMediumPct: 35,
  marginHardPct: 50,
  ivaPercentage: 22,
  cardFeePercentage: 1.5,
  cardFixedFee: 0.20,
  marginType: 'fixed', // 'fixed' | 'percentage' | 'auto'
  autoMarginThreshold: 30,
  defaultCardPayment: false,
};
